<template>
  <BaseBlock title="Connexion étudiant extérieur à l'Université de Lille">
    <v-form v-model="valid" ref="form">
      <BaseAlert :error="error" />
      <v-row>
        <v-col cols="12 pa-0">
          <v-text-field
            v-model="recherche.email"
            label="Adresse mail"
            :rules="mailRules"
            @input="resetApiErrors('email')"
            :error-messages="checkApiErrors('email')"
            outlined
            shaped
            required
          ></v-text-field>
        </v-col>

        <v-col cols="12 pa-0">
          <v-text-field
            v-model="recherche.mdp"
            label="Mot de passe"
            @input="resetApiErrors('mdp')"
            :rules="passwordRules"
            :error-messages="checkApiErrors('mdp')"
            :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
            :type="show1 ? 'text' : 'password'"
            @click:append="show1 = !show1"
            outlined
            shaped
            required
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <div class="text-center">
            <v-btn
              class="mx-2"
              color="primary"
              @click="connexion"
              :disabled="!valid"
              >Connexion</v-btn
            >
          </div>
        </v-col>
        <v-col cols="12">
          <div class="text-center">
            <router-link to="/nouveauCompte">
              <v-btn small class="mx-2" color="primary">Créer un compte</v-btn>
            </router-link>
            <router-link to="/oubliMDP">
              <v-btn small class="mx-2" color="primary"
                >Mot de passe oublié</v-btn
              >
            </router-link>
          </div>
        </v-col>
      </v-row>
    </v-form>
  </BaseBlock>
</template>

<script>
import BaseBlock from "@/components/base/BaseBlock";
import BaseForm from "@/components/base/BaseForm";
import ApiGestionCompte from "@/repositories/ApiGestionCompte";
import BaseAlert from "@/components/base/BaseAlert";

export default {
  name: "ConnexionExterieurs",
  components: { BaseBlock, BaseAlert },
  extends: BaseForm,
  data() {
    return {
      recherche: {
        email: "",
        mdp: "",
      },
      show1: false,
      message: null,
      pattern:
        /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#?$%^&*=+;:.])(?=.{10,})/,
      mailRules: [
        (v) =>
          /^\w+([\\.-]?\w+)*@\w+([\\.-]?\w+)*(\.\w{2,3})+$/.test(v) ||
          "E-mail doit être valide",
      ],
      passwordRules: [
        (v) =>
          this.pattern.test(v) ||
          "Min. 10 caractères avec au moins une majuscule, une minuscule, un chiffre et un caractère spécial !@#?$%^&*=+;.:",
      ],
    };
  },
  methods: {
    async connexion() {
      try {
        await ApiGestionCompte.connexionExterieur(this.recherche);
        this.$store.dispatch("loadUser");
        window.location.href = process.env.VUE_APP_HOST_URL;
      } catch (error) {
        this.populateErrors(error);
        this.$toast.error("Compte non reconnu.");
      }
    },
  },
};
</script>
